(function() {
  var Toolbar,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Toolbar = App.loadClass("grower::classes/data/planting_rx/TruthStripToolbar");

  exports.register = function(module) {
    return module.factory("Grower.Services.TruthStripToolbar", [
      "$rootScope", "Core.Services.Map", function() {
        return (function(func, args, ctor) {
          ctor.prototype = func.prototype;
          var child = new ctor, result = func.apply(child, args);
          return Object(result) === result ? result : child;
        })(exports.TruthStripToolbar, arguments, function(){});
      }
    ]);
  };

  exports.TruthStripToolbar = (function() {
    function TruthStripToolbar(rootScope, map) {
      this.rootScope = rootScope;
      this.map = map;
      this._fieldCrop = bind(this._fieldCrop, this);
      this._cropToField = bind(this._cropToField, this);
      this._updateAreas = bind(this._updateAreas, this);
      this._safeApply = bind(this._safeApply, this);
      this.deleteArea = bind(this.deleteArea, this);
      this.loadPolygons = bind(this.loadPolygons, this);
      this.show = bind(this.show, this);
      this.getAreas = bind(this.getAreas, this);
      this.getMode = bind(this.getMode, this);
      this.reset = bind(this.reset, this);
      this.events = new L.MassEvents();
      this.areas = [];
      this.uncropped_strips = [];
    }

    TruthStripToolbar.prototype.reset = function() {
      this.areas = [];
      return this.hide();
    };

    TruthStripToolbar.prototype.initEvents = function() {
      this.events.on([[App.map, ['draw:created']], [this.toolbar, ['toolbar:shape-added', 'post-add-feature']]], this._cropToField);
      return this.events.on([[App.map, ['draw:point-edited', 'draw:point-removed']], [this.toolbar, ['toolbar:shape-added', 'delete:layer-deleted']]], this._updateAreas);
    };

    TruthStripToolbar.prototype.getMode = function() {
      return this.mode;
    };

    TruthStripToolbar.prototype.getAreas = function() {
      return this.areas;
    };

    TruthStripToolbar.prototype.show = function() {
      var ref;
      this.toolbar = new Toolbar();
      this.loadPolygons(this.areas);
      this.initEvents();
      this.field = (ref = this.map.getByName("field-boundary")) != null ? ref.feature : void 0;
      this.mode = this.toolbar.drawMode();
      this.toolbar.drawMode.subscribe((function(_this) {
        return function(value) {
          _this.mode = value;
          return _this._safeApply();
        };
      })(this));
      return this.toolbar.init();
    };

    TruthStripToolbar.prototype.loadPolygons = function(polys) {
      var area, j, len, results;
      if (this.toolbar != null) {
        this.toolbar.drawnItems = new L.FeatureGroup();
        results = [];
        for (j = 0, len = polys.length; j < len; j++) {
          area = polys[j];
          if (area.poly_raw != null) {
            area.poly = L.geoJson(JSON.parse(area.poly_raw)).getLayers()[0];
            delete area.poly_raw;
          }
          results.push(this.toolbar.drawnItems.addLayer(area.poly));
        }
        return results;
      }
    };

    TruthStripToolbar.prototype.hide = function() {
      if (this.toolbar != null) {
        this.toolbar.destroy();
      }
      return this.events.destroy();
    };

    TruthStripToolbar.prototype.deleteArea = function(strip) {
      this.toolbar.disableCurrent();
      this.toolbar.drawnItems.removeLayer(strip.poly);
      return this._updateAreas();
    };

    TruthStripToolbar.prototype.newStrip = function() {
      return this.toolbar.startDrawStrip();
    };

    TruthStripToolbar.prototype._safeApply = function(apply) {
      if (apply == null) {
        apply = function() {
          return void 0;
        };
      }
      if (this.rootScope && (this.rootScope.$$phase !== '$apply' && this.rootScope.$$phase !== '$digest')) {
        return this.rootScope.$apply(apply);
      }
    };

    TruthStripToolbar.prototype._updateAreas = function() {
      var acres, areas, i, j, len, poly, ref, total_acres;
      areas = [];
      total_acres = 0.0;
      ref = this.toolbar.getAreas();
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        poly = ref[i];
        acres = L.GeoUtil.getAcreage(poly);
        if ((acres != null) && $.isNumeric(acres)) {
          acres = parseFloat(acres);
          total_acres += acres;
          acres = acres.toFixed(1);
        }
        areas.push({
          acres: acres,
          poly: poly
        });
      }
      this.areas = areas;
      return this._safeApply();
    };

    TruthStripToolbar.prototype._cropToField = function() {
      var collection;
      if (this.toolbar.drawnItems.getLayers().length === 0) {
        return;
      }
      collection = new L.FeatureGroup();
      this.toolbar.drawnItems.eachLayer((function(_this) {
        return function(layer) {
          var curr;
          curr = _this._fieldCrop(layer);
          return collection.addLayer(curr);
        };
      })(this));
      this.toolbar.drawnItems.clearLayers();
      L.GeoUtil.unnestAdd(this.toolbar.drawnItems, collection);
      return this.toolbar._setStyles();
    };

    TruthStripToolbar.prototype._fieldCrop = function(area) {
      var curr, f;
      f = this.field;
      curr = L.GeoUtil.combine(area, f, 'intersection');
      curr = L.GeoUtil.readFromJSTS(curr);
      L.GeoUtil.prune(curr);
      return curr;
    };

    return TruthStripToolbar;

  })();

}).call(this);
